import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { XpAvatarComponent } from '../avatar/xp-avatar.component';

export interface XpHeaderHelpItem {
	id: string;
	label: string;
	icon?: string;
}

@Component({
	selector: 'xp-header',
	standalone: true,
	imports: [CommonModule, MatDividerModule, MatIconModule, MatMenuModule, XpAvatarComponent],
	templateUrl: './xp-header.component.html',
	styleUrls: ['./xp-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpHeaderComponent {
	logoSrc = input('');
	logoAlt = input('');
	portalName = input('');
	badge = input('');
	userName = input('');
	userRole = input('');
	userAvatar = input('');
	code = input('');
	codeLabel = input('');
	showHelp = input(false);
	helpIconSrc = input('');
	helpMenuItems = input<XpHeaderHelpItem[]>([]);
	helpClick = output<void>();
	helpMenuSelect = output<string>();
	codeCopy = output<string>();
	profileClick = output<void>();
	logout = output<void>();

	readonly initials = computed(() => {
		const parts = this.userName().trim().split(/\s+/).filter(Boolean);
		if (parts.length === 0) {
			return '?';
		}
		if (parts.length === 1) {
			return parts[0].slice(0, 2).toUpperCase();
		}
		return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	});

	onCopy(event: MouseEvent): void {
		event.stopPropagation();
		this.codeCopy.emit(this.code());
	}
}
